<template>
	<div @click="onAccessorySelected" :class="{'selected' : accessoryProp == accessorySelected}" class="accessory">
		<img :src="accessoryProp.thumbnail" :alt="accessoryProp.title" class="img product-options__img product-options__img--accessory product-options__img--selection">
		<p class="product-options__title">{{ accessoryProp.title }}</p>
	</div>
</template>

<script>
	export default {
		props: ['accessoryProp'],
		data() {
			return {
				accessorySelected: null
			};
		},
		methods: {
			onAccessorySelected: function() {
				if (this.accessorySelected == this.accessoryProp) {
					this.accessorySelected = null;
					this.$emit('accessoryRemoved', this.accessoryProp);
				} else {
					this.accessorySelected = this.accessoryProp;
					this.$emit('accessorySelected', this.accessoryProp);
				}
			}
		},
	};
</script>

<style scoped>
	.accessory {
		flex: 0 0 calc(100% / 3 - 1rem);
		margin: 0 0.5rem 1rem;
		display: flex;
		align-items: center;
	}

	.accessory.selected > img {
		opacity: 1;
		border: 1px solid #a8d5e9;
	}

	.accessory:hover {
		cursor: pointer;
	}

	.accessory img {
		margin: 0 0.5rem 0 0;
		display: inline-block;
	}

	.accessory p {
		display: inline-block;
	}
</style>